const commsLanguageDisplayText = {
  es: 'SPANISH',
  en: 'ENGLISH',
};

export default commsLanguageDisplayText;
